import React from 'react';
import DragIcon from 'mdi-react/DragIcon';
import NewspaperIcon from 'mdi-react/NewspaperIcon';
import StadiumIcon from 'mdi-react/StadiumIcon';
import ImageAreaIcon from 'mdi-react/ImageAreaIcon';
import CloverIcon from 'mdi-react/CloverIcon';
import CalendarIcon from 'mdi-react/CalendarIcon';
import TableIcon from 'mdi-react/TableIcon';
import { partial } from '../../util/translation/translation';
import componentName from './componentName';

const s = partial('shared');

const Row = ({ icon: Icon, id, lifted }) => (
  <div
    className={`layout-drag__row${lifted ? ' layout-drag__row--lifted' : ''}`}
  >
    <DragIcon size={16} className="layout-drag__grip" />
    <span className="layout-drag__icon">
      <Icon size={16} />
    </span>
    {componentName(id)}
  </div>
);

/**
 * The App layout page's two columns in miniature, mid-drag: the lottery
 * lifted out of Available, on its way to the gap in Active.
 */
const LayoutDragPreview = () => (
  <div className="layout-drag" aria-hidden>
    <div className="layout-drag__col">
      <strong>{s('Available')}</strong>
      <div className="layout-drag__list">
        <Row icon={CloverIcon} id="lottery" lifted />
        <Row icon={CalendarIcon} id="events" />
        <Row icon={TableIcon} id="standings" />
      </div>
    </div>
    <div className="layout-drag__col">
      <strong>{s('Active')}</strong>
      <div className="layout-drag__list layout-drag__list--over">
        <Row icon={NewspaperIcon} id="news" />
        <div className="layout-drag__slot" />
        <Row icon={StadiumIcon} id="matchCenter" />
        <Row icon={ImageAreaIcon} id="spotlight" />
      </div>
    </div>
  </div>
);

export default LayoutDragPreview;
